export function SettingsPage() {
  return (
    <div data-testid="settings-page">
      <div className="space-y-2" data-testid="settings-header">
        <h1 className="text-2xl font-semibold tracking-tight lg:text-3xl">
          Settings
        </h1>
        <p className="text-muted-foreground">
          Configure your application settings.
        </p>
      </div>
      
      <div data-testid="settings-content">
        <div className="rounded-lg border border-dashed border-gray-200 p-8 text-center">
          <h3 className="text-lg font-medium">Coming Soon</h3>
          <p className="text-muted-foreground">
            Settings interface will be implemented in Epic 2.
          </p>
        </div>
      </div>
    </div>
  )
}